import { Sun, Moon } from 'lucide-react'
import { useThemeStore } from '@/stores/themeStore'

export function ThemeToggle() {
  const { theme, toggleTheme } = useThemeStore()
  const isDark = theme === 'dark'

  return (
    <button
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
      className={[
        'w-8 h-8 rounded-lg flex items-center justify-center',
        'border border-[#1E1E1E] bg-[#141414]',
        'hover:border-[#E8850C] hover:text-[#E8850C]',
        'text-[#A0A0A0] transition-all duration-200',
        'focus-visible:ring-2 focus-visible:ring-[#E8850C] focus-visible:outline-none',
      ].join(' ')}
    >
      {isDark ? <Sun size={14} strokeWidth={1.75} /> : <Moon size={14} strokeWidth={1.75} />}
    </button>
  )
}
